export default function Features() {
  const features = [
    {
      number: '01',
      title: 'Agentes de Atención 24/7',
      description:
        'Desplegamos agentes de IA entrenados para entender tu negocio. Responden consultas, califican leads y atienden a tus clientes por WhatsApp o Web — sin descanso y sin errores.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="14" y="14" width="20" height="20" rx="2" stroke="#9B6FE4" strokeWidth="1.8" />
          <rect x="18" y="18" width="12" height="12" rx="1" stroke="#9B6FE4" strokeWidth="1.4" opacity="0.85" />
          <line x1="20" y1="14" x2="20" y2="6" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="28" y1="14" x2="28" y2="6" stroke="#9B6FE4" strokeWidth="1.4" />
          <rect x="17" y="2" width="6" height="4" rx="1" stroke="#9B6FE4" strokeWidth="1.2" />
          <rect x="25" y="2" width="6" height="4" rx="1" stroke="#9B6FE4" strokeWidth="1.2" />
          <line x1="20" y1="34" x2="20" y2="42" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="28" y1="34" x2="28" y2="42" stroke="#9B6FE4" strokeWidth="1.4" />
          <rect x="17" y="42" width="6" height="4" rx="1" stroke="#9B6FE4" strokeWidth="1.2" />
          <rect x="25" y="42" width="6" height="4" rx="1" stroke="#9B6FE4" strokeWidth="1.2" />
          <line x1="14" y1="20" x2="6" y2="20" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="14" y1="28" x2="6" y2="28" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="34" y1="20" x2="42" y2="20" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="34" y1="28" x2="42" y2="28" stroke="#9B6FE4" strokeWidth="1.4" />
        </svg>
      ),
    },
    {
      number: '02',
      title: 'Flujos que Conectan Todo',
      description:
        'Hacemos que tus herramientas hablen entre sí. WhatsApp, calendarios, hojas de cálculo, CRMs — eliminamos el trabajo manual de pasar datos de un lado al otro.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="5" stroke="#9B6FE4" strokeWidth="1.8" />
          <circle cx="24" cy="24" r="2" fill="#9B6FE4" opacity="0.7" />
          <line x1="24" y1="19" x2="24" y2="6" stroke="#9B6FE4" strokeWidth="1.2" />
          <circle cx="24" cy="4" r="3" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="28.3" y1="21.5" x2="40" y2="12" stroke="#9B6FE4" strokeWidth="1.2" />
          <circle cx="41.5" cy="10.5" r="3" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="28.3" y1="26.5" x2="40" y2="36" stroke="#9B6FE4" strokeWidth="1.2" />
          <circle cx="41.5" cy="37.5" r="3" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="24" y1="29" x2="24" y2="42" stroke="#9B6FE4" strokeWidth="1.2" />
          <circle cx="24" cy="44" r="3" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="19.7" y1="26.5" x2="8" y2="36" stroke="#9B6FE4" strokeWidth="1.2" />
          <circle cx="6.5" cy="37.5" r="3" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="19.7" y1="21.5" x2="8" y2="12" stroke="#9B6FE4" strokeWidth="1.2" />
          <circle cx="6.5" cy="10.5" r="3" stroke="#9B6FE4" strokeWidth="1.4" />
        </svg>
      ),
    },
    {
      number: '03',
      title: 'Auditoría de Eficiencia',
      description:
        'Analizamos tu operación actual para detectar dónde pierdes tiempo y dinero. Cada solución que diseñamos tiene un impacto directo en tu rentabilidad.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="4" width="40" height="40" rx="3" stroke="#9B6FE4" strokeWidth="1.8" />
          <line x1="4" y1="12" x2="44" y2="12" stroke="#9B6FE4" strokeWidth="1.4" />
          <circle cx="9" cy="8" r="1.2" fill="#9B6FE4" opacity="0.8" />
          <circle cx="13.5" cy="8" r="1.2" fill="#9B6FE4" opacity="0.8" />
          <circle cx="18" cy="8" r="1.2" fill="#9B6FE4" opacity="0.8" />
          <polyline points="10,36 16,30 22,33 28,22 34,26 40,18" stroke="#9B6FE4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          <circle cx="28" cy="22" r="2.5" stroke="#9B6FE4" strokeWidth="1.4" />
          <circle cx="28" cy="22" r="1" fill="#9B6FE4" />
          <line x1="10" y1="38" x2="40" y2="38" stroke="#9B6FE4" strokeWidth="0.8" opacity="0.4" />
          <line x1="10" y1="32" x2="40" y2="32" stroke="#9B6FE4" strokeWidth="0.8" opacity="0.4" />
          <line x1="10" y1="26" x2="40" y2="26" stroke="#9B6FE4" strokeWidth="0.8" opacity="0.4" />
          <line x1="10" y1="20" x2="40" y2="20" stroke="#9B6FE4" strokeWidth="0.8" opacity="0.4" />
        </svg>
      ),
    },
    {
      number: '04',
      title: 'Herramientas a Medida',
      description:
        'Construimos asistentes y paneles de control específicos para tu equipo. Sin software genérico — la herramienta exacta que tu negocio necesita.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="2" width="40" height="32" rx="3" stroke="#9B6FE4" strokeWidth="1.8" />
          <line x1="24" y1="34" x2="24" y2="40" stroke="#9B6FE4" strokeWidth="1.4" />
          <line x1="16" y1="40" x2="32" y2="40" stroke="#9B6FE4" strokeWidth="1.8" strokeLinecap="round" />
          <rect x="8" y="7" width="18" height="3" rx="1" stroke="#9B6FE4" strokeWidth="1" opacity="0.7" />
          <rect x="8" y="13" width="14" height="3" rx="1" stroke="#9B6FE4" strokeWidth="1" opacity="0.7" />
          <rect x="8" y="19" width="16" height="3" rx="1" stroke="#9B6FE4" strokeWidth="1" opacity="0.7" />
          <rect x="8" y="25" width="12" height="3" rx="1" stroke="#9B6FE4" strokeWidth="1" opacity="0.7" />
          <rect x="30" y="22" width="4" height="6" rx="0.5" fill="#9B6FE4" opacity="0.6" />
          <rect x="35" y="18" width="4" height="10" rx="0.5" fill="#9B6FE4" opacity="0.8" />
          <rect x="30" y="12" width="4" height="4" rx="0.5" fill="#9B6FE4" opacity="0.5" />
          <rect x="35" y="8" width="4" height="8" rx="0.5" fill="#9B6FE4" opacity="0.7" />
          <circle cx="40" cy="5" r="1.5" fill="#9B6FE4" opacity="0.9" />
        </svg>
      ),
    },
  ];

  return (
    <section id="services" className="relative py-20 bg-[#080810] overflow-hidden">
      {/* Subtle violet glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#7B3FE4]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-8">
        {/* Section Label */}
        <div className="mb-14">
          <div className="flex items-center gap-3">
            <div className="w-8 h-[2px] bg-[#7B3FE4]" />
            <span
              className="text-[#7B3FE4] uppercase font-medium"
              style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '13px !important', letterSpacing: '0.2em' }}
            >
              Lo que hacemos
            </span>
          </div>
        </div>

        {/* Services Grid - 2x2 with border separators */}
        <div className="grid grid-cols-1 sm:grid-cols-2 border border-white/[0.06]">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`group relative flex flex-row items-center gap-6 p-8 transition-all duration-300 cursor-pointer
                ${index === 0 ? 'border-r border-b border-white/[0.06]' : ''}
                ${index === 1 ? 'border-b border-white/[0.06]' : ''}
                ${index === 2 ? 'border-r border-white/[0.06]' : ''}
                hover:bg-[#7B3FE4]/[0.03]
              `}
              style={{ maxHeight: 'none' }}
            >
              {/* Icon — glowing container */}
              <div className="flex-shrink-0 flex items-center justify-center w-[72px] h-[72px] relative">
                <div
                  className="w-[72px] h-[72px] flex items-center justify-center relative transition-all duration-300 group-hover:scale-105"
                  style={{
                    borderRadius: '4px',
                    background: 'rgba(123, 63, 228, 0.25)',
                    border: '1px solid rgba(155, 111, 228, 0.5)',
                    boxShadow: '0 0 30px rgba(123,63,228,0.8), 0 0 60px rgba(123,63,228,0.4), inset 0 0 20px rgba(123,63,228,0.15)',
                  }}
                >
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                      borderRadius: '4px',
                      background: 'radial-gradient(circle at center, rgba(155,111,228,0.45) 0%, rgba(123,63,228,0.15) 50%, transparent 75%)',
                    }}
                  />
                  <div
                    className="relative z-10"
                    style={{ filter: 'drop-shadow(0 0 10px rgba(155,111,228,0.9)) drop-shadow(0 0 20px rgba(123,63,228,0.6))' }}
                  >
                    {feature.icon}
                  </div>
                </div>
              </div>

              {/* Text content */}
              <div className="flex flex-col flex-1 min-w-0">
                {/* Number */}
                <div
                  className="text-[#8887A0] text-xs mb-2 tracking-wider"
                  style={{ fontFamily: 'JetBrains Mono, monospace' }}
                >
                  {feature.number}
                </div>

                {/* Title */}
                <h3
                  className="text-[#F0EFF8] mb-2 leading-tight"
                  style={{ fontFamily: 'Sora, sans-serif', fontSize: '20px', fontWeight: 700 }}
                >
                  {feature.title}
                </h3>

                {/* Description */}
                <p
                  className="text-[#8887A0]"
                  style={{ fontFamily: 'Sora, sans-serif', fontSize: '16px', lineHeight: '1.75' }}
                >
                  {feature.description}
                </p>
              </div>

              {/* Hover glow border */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div
                  className="absolute inset-0 border border-[#7B3FE4]/20"
                  style={{ boxShadow: '0 0 20px rgba(123, 63, 228, 0.1)' }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}